import { getStoreId } from "$/hooks/use-store-information"
import servicePackageQueries from "$/lib/queries/service-package-queries"
import washQueries from "$/lib/queries/wash-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/settings/service-packages")({
  loader: async ({ context: { queryClient } }) => {
    const storeId = await getStoreId()
    if (storeId) {
      queryClient.prefetchQuery(servicePackageQueries.list({ storeId }))
      queryClient.prefetchQuery(washQueries.list({ storeId }))
    }

    return {
      crumb: "alfred.settings.nav.servicePackages.label",
    }
  },
})
